<template>
    <b-card style="width:25%;min-width:30rem;margin: auto;font-size: 1em;">
        <b-row class="m-3" style="font-weight: bold; text-align: start; margin-bottom:10px; color:#022B49;font-size: 1.75em;">
            <b-col>
                <span style="text-align: center;">
                        {{$t('userTitle')}}
                </span>
            </b-col>
        </b-row>
        <b-row class="m-3 mt-5">
            <b-col>
                <div class="item">
                <b-avatar size="8em" :src="user.profilePic"></b-avatar>
                    <file-upload
                        v-if="canEdit"
                        class="edit-badge"
                        extensions="gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp"
                        name="avatar"
                        :drop="true"
                        v-model="profilePic"
                        @input-file="inputFile"
                        style="cursor: pointer"
                    >       
                        <div style="cursor: pointer">
                            <i class='fas fa-pen'></i>
                        </div>
                    </file-upload>
	            </div>
            </b-col>
        </b-row>
        <b-modal
            modal-class="modal-fullscreen"
            style="height: 100vh"
            @ok="saveProfilePic"
            size="md"
            v-model="showCropImageModal"
            :title="$t('editPhoto')"
            :ok-title="$t('ok')"
            :cancel-title="$t('cancel')"
        >
            <VueCropper
                style="max-height:500px"
                :aspectRatio="1 / 1"
                :initialAspectRatio="1 / 1"
                ref="cropper"
                :src="profilePicSrc"
                alt="Source Image"
            ></VueCropper>
        </b-modal>
        <b-row class="m-3">
            <b-col>
                <span class="groupTitle" style="margin-top:10px;">
                        {{$t('personalInformationSubTitle')}}
                </span>
            </b-col>
        </b-row>
        <b-row class="m-3 mt-4">
            <b-col>
                <span class="fieldTitle" style="margin-bottom: 3px;">
                        {{$t('firstName')+'*'}}
                </span>
                <b-form-input :disabled="!canEdit" v-model="user.firstName" :placeholder="canEdit ? $t('firstNamePlaceholder') : ''" type="text" :class="{'is-invalid': errors.firstName }"/>
                <span v-if="errors.firstName" class="validation-error">{{$t('firstNameValidationError')}}</span>
            </b-col>
            <b-col>
                <span class="fieldTitle" style="margin-bottom: 3px;">
                        {{$t('lastName')+'*'}}
                </span>
                <b-form-input :disabled="!canEdit" v-model="user.lastName" :placeholder="canEdit ? $t('lastNamePlaceholder') : ''" type="text" :class="{'is-invalid': errors.lastName }"/>
                <span v-if="errors.lastName" class="validation-error">{{$t('lastNameValidationError')}}</span>
            </b-col>
        </b-row>
        <b-row class="m-3 mt-4">
            <b-col>
                <span class="fieldTitle" style="margin-bottom: 3px;">
                        {{$t('email')+'*'}}
                </span>
                <b-input-group class="profile-input-group">
                    <b-input-group-prepend is-text>
                        <i class="fas fa-envelope" style="color:#8e9097;"></i>
                    </b-input-group-prepend>
                    <b-form-input :disabled="!canEdit" v-model="user.email" :placeholder="canEdit ? $t('emailPlaceholder') : ''" type="text" :class="{'is-invalid': errors.email || errors.validEmail }"/>
                </b-input-group>
                <span v-if="errors.validEmail" class="validation-error">{{$t('emailValidationError')}}</span>
            </b-col>
        </b-row>
        <b-row class="m-3 mt-4">
            <b-col>
                <span class="fieldTitle" style="margin-bottom: 3px;">
                        {{$t('department')}}
                </span>
                <b-input-group class="profile-input-group">
                    <b-input-group-prepend is-text>
                        <span class="fas fa-users" style="color:#8e9097;"></span>
                    </b-input-group-prepend>
                    <b-form-input :disabled="!canEdit" v-model="user.department" type="text"/>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row class="m-3 mt-4">
            <b-col>
                <span class="fieldTitle" style="margin-bottom: 2px;">
                        {{$t('jobTitle')}}
                </span>
                <b-input-group class="profile-input-group">
                    <b-input-group-prepend is-text>
                        <span class="fas fa-briefcase" style="color:#8e9097;"></span>
                    </b-input-group-prepend>
                    <b-form-input :disabled="!canEdit" v-model="user.jobTitle" type="text"/>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row class="m-3"> 
            <b-col>
                <span class="groupTitle" style="margin-top:20px;">
                        {{$t('languagePreference')}}
                </span>
                <b-input-group class="mt-5 profile-input-group">
                    <b-input-group-prepend is-text >
                        <span class="fas fa-language" style="color:#8e9097;"></span>
                    </b-input-group-prepend>
                        <b-form-select 
                            :disabled="!canEdit"
                            :value="this.selectLocaleText()"
                            v-model="user.language" 
                            @change="changeLocale">
                            <option :value="'tr'">{{$t('turkish')}}</option>
                            <option :value="'en'">{{$t('english')}}</option>
                        </b-form-select>
                </b-input-group>
            </b-col>
        </b-row>
        <template v-if="this.$store.state.user.permissions.isAdmin">
            <b-row class="m-3"> 
                <b-col>
                    <span class="groupTitle" style="margin-top:10px;">{{$t('permissionsTitle')}}</span>
                </b-col>
            </b-row>
            <b-row class="m-3"> 
                <b-col>
                    <span class="fieldTitle">{{$t('rolesGroups')}}</span>
                    <treeselect
                            :key="$store.state.locale" 
                            v-model="user.groupId"
                            :multiple="true"
                            :max-height="300"
                            :options="userGroups"
                            @input="setUserGroup"
                        />
                </b-col>
            </b-row>
            <b-row class="m-3"> 
                <b-col>
                    <span class="fieldTitle">{{$t('locations')}}</span>
                    <site-multi-select-tree
                            :disabled="!canEdit"
                            :givenSites="allSites"
                            :givenSelectedSites="getSelectedSiteIds()"
                            @oninput="selectSite"
                            />
                </b-col>
            </b-row>
        </template>
        <b-row v-if="canEdit" class="m-1" style="float: right;"> 
            <b-col>
                <b-button @click="updateUser()" variant="success" :disabled="ppLoading">{{ $t('update') }}</b-button>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import SiteMultiSelectTree from '../../components/SiteMultiSelectTree.vue';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import _ from 'lodash';

export default {
    name: 'UserProfile',
    components: {
        VueCropper,
        Treeselect,
        SiteMultiSelectTree
    },
    data() {
        return {
            rawUser: {
                id: null,
                customerId: null,
                email: null,
                firstName: null,
                lastName: null,
                groupId: [],
                assignedSites: [],
                status: null,
                language: null,
                jobTitle: null,
                department: null,
                signupDate: null,
                lastLoginDate: null,
                disableDate: null,
                inviteDate: null,
                inviteCount: null,
                inviteUUID: null,
                profilePic: null
            },
            user: {
                id: null,
                customerId: null,
                email: null,
                firstName: null,
                lastName: null,
                groupId: [],
                assignedSites: [],
                status: null,
                language: null,
                jobTitle: null,
                department: null,
                signupDate: null,
                lastLoginDate: null,
                disableDate: null,
                inviteDate: null,
                inviteCount: null,
                inviteUUID: null,
                profilePic: null
            },
            ppLoading: false,
            profilePic: [],
            profilePicSrc: '',
            showCropImageModal: false,
            croppedImage: '',
            canEditUser: false,
            allSites: [],
            selectedSites: [],
            userGroups:[],
            rawUserGroups:[],
            errors: {
                firstName: false,
                lastName: false,
                email: false,
                validEmail: false,
            },
        };
    },
    methods: {
        saveProfilePic() {
            let file = this.profilePic[0] && this.profilePic[0].file;
            let imageData = this.$refs.cropper.getCroppedCanvas().toDataURL();
            return this.uploadFile(imageData, file);
        },
        uploadFile(base64Data, file) {
            this.$Progress.start();
            this.ppLoading = true;
            return this.axios
                .post(`/uploadToAws`, {
                    data: base64Data,
                    type: 'profile-pic',
                    mimeType: _.get(file, 'type'),
                    size: _.get(file, 'size'),
                    originalFileName: _.get(file, 'name'),
                    userIdOverWrite: _.get(this.user, 'id')
                })
                .then(({data}) => {
                    this.$message({
                        type: 'success',
                        message: this.$t('profilePhotoUploadSuccesfully')
                    });
                    this.user.profilePic = _.get(data, 'url');
                    this.user.avatarId = _.get(data, 'id');
                    this.ppLoading = false;
                    this.$Progress.finish();
                    return data;
                });
        },
        inputFile() {
            this.showCropImageModal = true;
            let file = this.profilePic[0] && this.profilePic[0].file;
            if (file) {
                let FR = new FileReader();
                FR.readAsDataURL(file);
                FR.onload = event => {
                    this.profilePicSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.replace(event.target.result);
                };
            }
        },
        changeLocale(newVal) {
            this.user.language = newVal;
        },
        selectSite(value){
            _.set(this.user, 'assignedSites', this.getSiteIdsInGroupedSitesMap(value))
        },
        getSelectedSiteIds(){
            return this.createGroupedSitesKeys(this.user.assignedSites);
        },
        setUserGroup(val){
            this.user.groupId = val;
        },
        updateUser(){
            if(this.isUpdateValid()){
                let adminId = _.first(_.map(_.filter(this.rawUserGroups, o=> o.type == 'admin'), 'id'));
                let supervisorId = _.first(_.map(_.filter(this.rawUserGroups, o=> o.type == 'supervisor'), 'id'));
                if((
                        !_.isEmpty(_.filter(this.rawUser.groupId, o=>adminId==o)) 
                            && _.isEmpty(_.filter(this.user.groupId, o=>adminId==o))
                        ) 
                        || (
                            !_.isEmpty(_.filter(this.rawUser.groupId, o=>supervisorId==o)) 
                            && _.isEmpty(_.filter(this.user.groupId, o=>supervisorId==o))
                        )
                    ){
                    this.user.groupId.push(adminId);
                    return this.$message({
                        type: 'error',
                        message: this.$t('adminGroupError')
                    });
                }
                else{
                    this.$Progress.start();
                    this.axios.put(`/user`, this.user).then((response) => {
                        if(response.data.error != 'E-mail already in use'){
                            this.rawUser = response.data;
                            this.user = _.clone(this.rawUser);
                            if(this.canEditUser){
                                if(this.user.language != this.$store.state.locale) {
                                    this.$store.state.locale = this.user.language;
                                    localStorage.setItem('locale', this.user.language);
                                    this.$root.$i18n.locale = this.$store.state.locale;
                                    this.init();
                                }
                                
                                if(this.user.email != this.$store.state.user.email){
                                    this.$store.state.user.email = this.user.email;
                                    localStorage.setItem('token', response.data.token);
                                    document.cookie = `Authorization=Bearer ${response.data.token}`;
                                    this.$store.state.token = `Bearer ${response.data.token}`;
                                    this.axios.defaults.headers.Authorization = response.data.token
                                        ? `Bearer ${response.data.token}`
                                        : 'Bearer ';
                                    this.$store.dispatch('init');
                                }
                                
                                
                            }
                            this.$Progress.finish();
                            return this.$message({
                                type: 'success',
                                message: this.$t('UserUpdatedSuccessfully')
                            });
                        } else {
                            this.$Progress.finish();
                            return this.$message({
                                type: 'error',
                                message: this.$t('mailInUseError')
                            });
                        }
                    });
                }
            }
        },
        isUpdateValid() {
            this.errors.firstName = !this.user.firstName;
            this.errors.lastName = !this.user.lastName;
            this.errors.email = !this.user.email;
            this.errors.validEmail = !this.isEmailValid(this.user.email);
            let validation = true;
            for (let key in this.errors) {
                validation &= !this.errors[key];
            }
            return validation;
        },
        isEmailValid(email){
            return  email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
        },
        selectLocaleText(){
            if(this.user.language == 'tr'){
                return this.$t('turkish');
            } else {
                return this.$t('english');
            }
        },
        init(){
            let userId = this.route.params.user_id;
            this.canEditUser = this.$store.state.user.id == userId;
            this.allSites = this.sitesWithGroups;
            this.siteOptions = [{id:"All", label:this.$t('selectAll'), children:this.allSites, isDefaultExpanded:true}];
            this.axios.get(`/getUserData/${userId}`).then(({data})=>{
                this.rawUser = data;
                this.user = _.clone(this.rawUser);
                return this.axios
                    .get(`/permission-groups`)
                    .then(({data}) => {
                        this.rawUserGroups = data;
                        this.userGroups = _.map(this.rawUserGroups, userGroup=>({
                                id: _.get(userGroup, 'id'),
                                label: this.$t(this.getGroupName(_.get(userGroup, 'name')))
                            }));
                    });
            });
        }
    },
    computed: {
        canEdit() {
            return this.canEditUser || this.$store.state.user.permissions.isAdmin;
        }
        
    },
    watch:{
        '$route.path': function(){
            this.init();
        }
    },
    created() {
        this.init();
        /*
        this.permissionOptions = [{id:"All", label:this.$t('selectAll'), children:this.givenSites, isDefaultExpanded:true}];
        */
        
    }
};
</script>

<style lang="scss" scoped>

.profile-input-group .input-group-prepend .input-group-text {
  background-color: transparent !important;
}

.groupTitle {
    font-size: 1em;
    font-weight: 700;
    color:#022B49;
    float: left;
}
.fieldTitle {
    color:#0163aa;
    float: left;
}

.item {
    position:relative;
    display:inline-block;
}
.edit-badge{
    position: absolute;
    right:5px;
    bottom:-5px;
    background:#4972ce;
    text-align: center;
    border-radius: 50%;
    color:white;
    padding: 10px 10px;
    font-size: 20px;
}

.validation-error {
    color: red;
    float: left;
    font-size: .7em;
}


</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "userTitle": "Hesap",
            "personalInformationSubTitle": "Kişisel Bilgiler",
            "firstName": "Ad",
            "lastName": "Soyad",
            "email": "E-posta",
            "department": "Departman",
            "jobTitle": "Ünvan",
            "languagePreference": "Dil Seçimi",
            "permissionsTitle": "İzinler",
            "turkish": "Türkçe",
            "english": "İngilizce",
            "firstNamePlaceholder": "Ör: Ayşe",
            "lastNamePlaceholder": "Ör: Yılmaz",
            "emailPlaceholder": "Ör: ayse.yilmaz@mail.com",
            "departmentPlaceholder": "Ör: IT",
            "jobTitlePlaceholder": "Ör: Bilgisayar Mühendisi",
            "rolesGroups": "Roller/Gruplar",
            "locations": "Lokasyonlar",
            "selectRolesGroups": "Rol(ler) Seçin",
            "selectLocations": "Lokasyon(lar) Seçin",
            "selectAll": "Hepsini Seç",
            "firstNameValidationError": "Lütfen adınızı girin",
            "lastNameValidationError": "Lütfen soyadınızı girin",
            "emailValidationError": "Lütfen geçerli bir e-posta girin",
            "editPhoto": "Fotoğrafı Düzenle",
            "youCantRemoveAdminFromYourSelf": "Kendinizden admin yetkisini silemessiniz",
            "adminGroupError": "Admin grubundan kullanıcı çıkarma işlemi \"Kullanıcı İzinleri\" sayfasından yapılabilir",
            "mailInUseError": "Bu e-posta adresi başka bir kullanıcı tarafından kullanılıyor. Farklı bir e-posta adresi girin.",
            "UserUpdatedSuccessfully": "Güncelleme başarıyla tamamlandı",
            "profilePhotoUploadSuccesfully": "Profil Fotoğrafı Başarıyla Yüklendi"
        },
        "en": {
            "userTitle": "Account",
            "personalInformationSubTitle": "Personal Information",
            "firstName": "First Name",
            "lastName": "Last Name",
            "email": "Email",
            "department": "Department",
            "jobTitle": "Title",
            "languagePreference": "Language Preference",
            "permissionsTitle": "Permissions",
            "turkish": "Turkish",
            "english": "English",
            "firstNamePlaceholder": "Ex: John",
            "lastNamePlaceholder": "Ex: Doe",
            "emailPlaceholder": "Ex: john.doe@mail.com",
            "departmentPlaceholder": "Ex: IT",
            "jobTitlePlaceholder": "Ex: Software Engineer",
            "rolesGroups": "Roles/Groups",
            "locations": "Locations",
            "selectRolesGroups": "Select Role(s)",
            "selectLocations": "Select Location(s)",
            "selectAll": "Select All",
            "firstNameValidationError": "Please enter your first name",
            "lastNameValidationError": "Please enter your last name",
            "emailValidationError": "Please enter valid email.",
            "editPhoto": "Edit Photo",
            "youCantRemoveAdminFromYourSelf": "You can't delete admin from yourself",
            "adminGroupError": "Removing users from the Admin group can be done on the \"Permissions\" page.",
            "mailInUseError": "This email address is already used by another user. Enter a different email address.",
            "UserUpdatedSuccessfully": "Update completed successfully",
            "profilePhotoUploadSuccesfully": "Profile Photo Upload Successfully"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/UserProfile.vue